// extracted by mini-css-extract-plugin
export default {"cBlockTokenPair":"BlockTokenPair_cBlockTokenPair__klaWb"};